export default "__VITE_ASSET__DxIkwWGR__"